import { computed, ComputedRef } from 'vue';
import { FunctionKey } from '@/types';
import { parseAvailableFunctionKeys } from '@/utils/contractCapability';
import { useCurrentUser } from '@/utils/swr';

export const useFunctionAccess = (): {
  availableFunctions: ComputedRef<FunctionKey[] | null>;
  isLoading: ComputedRef<boolean>;
  hasError: ComputedRef<boolean>;
  canUse: (functionKey: FunctionKey) => boolean;
} => {
  const { data, error } = useCurrentUser();

  const availableFunctions = computed<FunctionKey[] | null>(() => {
    if (data.value === undefined) return null;

    const result = parseAvailableFunctionKeys(
      data.value.available_function_keys,
    );
    if (result.kind === 'error') return null;
    return result.keys;
  });

  const isLoading = computed(() => data.value === undefined && !error.value);
  const hasError = computed(() => error.value !== undefined);

  const canUse = (functionKey: FunctionKey): boolean =>
    availableFunctions.value?.includes(functionKey) ?? false;

  return { availableFunctions, isLoading, hasError, canUse };
};
